import * as React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { IS_DEPLOYMENT_ENV_STAGING, IS_DEPLOYMENT_ENV_TEST, IS_LOCAL } from "../../envVariables";
import { useAppSelector } from "../../store/hooks";
import { selectTitleName } from "../../store/titleSlice";
import { parseTitleFromUrl, buildTitle } from "./parseTitleFromUrl";

const TAGLINE = "From many clouds, one™";
const DEFAULT_TITLE = "Control Plane";

export const DocumentTitle: React.FC = () => {
  const { pathname } = useLocation();
  const titleNameFromRedux = useAppSelector(selectTitleName);
  const titleInfo = parseTitleFromUrl(pathname);

  const prefixParts: string[] = [];
  if (IS_LOCAL) prefixParts.push("L");
  if (IS_DEPLOYMENT_ENV_TEST) prefixParts.push("T");
  if (IS_DEPLOYMENT_ENV_STAGING) prefixParts.push("S");
  const prefix = prefixParts.length > 0 ? `${prefixParts.join(" ")} | ` : "";

  // Always render Helmet to ensure title updates properly during redirects
  const title = titleInfo ? buildTitle(titleInfo, titleNameFromRedux) : DEFAULT_TITLE;

  return (
    <Helmet>
      <title>
        {prefix}
        {title} - {TAGLINE}
      </title>
    </Helmet>
  );
};
